export type WorkType = "电影" | "电视剧";

export interface Work {
  id: string;
  title: string;
  type: WorkType;
  year: number;
  rating: number;
  heat: number;
  status: string;
  genre: string[];
  director: string;
  cast: string[];
  duration: string;
  region: string;
  cover: string;
  still: string;
  synopsis: string;
  featured?: boolean;
}

export const works: Work[] = [
  {
    id: "chang-ye-jiang-ming",
    title: "长夜将明",
    type: "电影",
    year: 2023,
    rating: 9.1,
    heat: 9860,
    status: "已上映",
    genre: ["悬疑", "剧情"],
    director: "周慕白",
    cast: ["沈亦舟", "苏晚宁", "顾承宇"],
    duration: "128分钟",
    region: "中国大陆",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20with%20a%20lone%20silhouette%20standing%20in%20a%20rainy%20dark%20alley%20under%20a%20single%20street%20lamp%2C%20deep%20navy%20and%20amber%20tones%2C%20moody%20dramatic%20lighting%2C%20minimal%20composition%2C%20high%20detail%20editorial%20key%20art&width=600&height=900&seq=work-cover-01&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20rainy%20city%20street%20at%20night%20with%20reflective%20wet%20asphalt%20and%20warm%20street%20lamps%2C%20deep%20navy%20tones%20with%20amber%20highlights%2C%20atmospheric%20moody%20film%20still%2C%20high%20detail&width=1600&height=900&seq=work-still-01&orientation=landscape",
    synopsis: "一场发生在暴雨之夜的连环失踪案，将刑警队长与一位沉默的目击者卷入同一张网。随着真相层层剥开，长夜中的那束光究竟指向救赎，还是更深的深渊。《长夜将明》以冷峻的镜头语言和缜密的叙事结构，讲述了一个关于选择与代价的故事。",
    featured: true,
  },
  {
    id: "shan-hai-xun-zong",
    title: "山海寻踪",
    type: "电视剧",
    year: 2024,
    rating: 8.8,
    heat: 9420,
    status: "热播中",
    genre: ["奇幻", "古装", "冒险"],
    director: "柳砚青",
    cast: ["江暮辞", "林知夏", "陆屿"],
    duration: "45分钟/集 · 全40集",
    region: "中国大陆",
    cover: "https://readdy.ai/api/search-image?query=epic%20fantasy%20chinese%20drama%20poster%20with%20ancient%20mountains%20floating%20in%20mist%20and%20a%20lone%20traveler%20with%20a%20lantern%2C%20deep%20indigo%20sky%20with%20warm%20golden%20accents%2C%20mythical%20atmosphere%2C%20minimal%20elegant%20key%20art&width=600&height=900&seq=work-cover-02&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20landscape%20of%20floating%20mountain%20peaks%20above%20a%20sea%20of%20clouds%20at%20dawn%2C%20deep%20indigo%20and%20warm%20amber%20light%2C%20epic%20scale%2C%20atmospheric%20film%20still&width=1600&height=900&seq=work-still-02&orientation=landscape",
    synopsis: "上古奇书《山海图》重现人间，一位出身平凡的少年被迫踏上寻踪之旅。他要在群山与深海之间寻找失落的文明碎片，也要在人心与欲望之间守住最初的信念。宏大的世界观与细腻的人物成长，共同织就一幅东方奇幻长卷。",
    featured: true,
  },
  {
    id: "gui-tu-lie-che",
    title: "归途列车",
    type: "电影",
    year: 2022,
    rating: 8.9,
    heat: 8120,
    status: "已上映",
    genre: ["剧情", "家庭"],
    director: "周慕白",
    cast: ["韩景轩", "白露", "叶清欢"],
    duration: "116分钟",
    region: "中国大陆",
    cover: "https://readdy.ai/api/search-image?query=warm%20emotional%20movie%20poster%20of%20an%20old%20train%20traveling%20through%20a%20snowy%20countryside%20at%20twilight%2C%20muted%20blue%20and%20soft%20orange%20glow%20from%20windows%2C%20nostalgic%20minimal%20composition%2C%20high%20detail&width=600&height=900&seq=work-cover-03&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=cinematic%20shot%20of%20an%20old%20train%20crossing%20a%20snow%20covered%20field%20at%20dusk%2C%20warm%20window%20lights%20against%20cold%20blue%20snow%2C%20nostalgic%20film%20still%2C%20high%20detail&width=1600&height=900&seq=work-still-03&orientation=landscape",
    synopsis: "每年春节，数以亿计的人踏上归途。影片跟随一列横跨南北的绿皮火车，记录三组普通家庭在路上的相遇与告别。没有宏大的宣言，只有被折叠在车厢里的沉默与牵挂。《归途列车》用最朴素的镜头，触碰了每个人心底那条回不去的路。",
  },
  {
    id: "wu-du-mi-guang",
    title: "雾都迷光",
    type: "电视剧",
    year: 2023,
    rating: 8.6,
    heat: 8760,
    status: "已完结",
    genre: ["犯罪", "悬疑"],
    director: "秦子墨",
    cast: ["顾承宇", "苏晚宁", "池砚"],
    duration: "42分钟/集 · 全36集",
    region: "中国大陆",
    cover: "https://readdy.ai/api/search-image?query=noir%20crime%20drama%20poster%20with%20foggy%20city%20skyline%20at%20night%20and%20a%20detective%20silhouette%20in%20a%20trench%20coat%2C%20deep%20blue%20fog%20with%20a%20single%20orange%20neon%20sign%2C%20moody%20minimal%20key%20art%2C%20high%20detail&width=600&height=900&seq=work-cover-04&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=cinematic%20noir%20city%20street%20in%20thick%20fog%20at%20night%20with%20orange%20neon%20reflections%20on%20wet%20pavement%2C%20deep%20blue%20moody%20atmosphere%2C%20film%20still%2C%20high%20detail&width=1600&height=900&seq=work-still-04&orientation=landscape",
    synopsis: "雾都接连发生的诡案背后，隐藏着一个跨越十年的约定。刑侦队长与犯罪心理顾问在迷雾中追逐同一个影子，却发现彼此都是棋局中早已落下的子。罪与罚的边界在浓雾里变得模糊，而真相，需要有人愿意伸手拨开。",
  },
  {
    id: "hai-di-de-xing-kong",
    title: "海底的星空",
    type: "电影",
    year: 2024,
    rating: 9.0,
    heat: 9150,
    status: "已上映",
    genre: ["科幻", "剧情"],
    director: "沈亦舟",
    cast: ["沈亦舟", "林知夏", "温以宁"],
    duration: "134分钟",
    region: "中国大陆",
    cover: "https://readdy.ai/api/search-image?query=scifi%20movie%20poster%20of%20a%20deep%20sea%20diver%20surrounded%20by%20glowing%20bioluminescent%20particles%20that%20resemble%20a%20starry%20sky%20underwater%2C%20deep%20teal%20and%20warm%20gold%20sparkles%2C%20minimal%20elegant%20key%20art%2C%20high%20detail&width=600&height=900&seq=work-cover-05&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=cinematic%20underwater%20scene%20of%20a%20deep%20sea%20trench%20with%20glowing%20blue%20marine%20snow%20particles%20and%20a%20small%20submersible%20with%20warm%20lights%2C%20vast%20atmospheric%20film%20still&width=1600&height=900&seq=work-still-05&orientation=landscape",
    synopsis: "当人类第一次抵达马里亚纳海沟最深处，声呐却捕捉到一段无法解释的规律信号。一名年轻的海洋工程师带着父亲的遗憾下潜，去寻找那个被深海藏了半个世纪的答案。《海底的星空》是一场关于孤独、信仰与未知的深海旅程。",
    featured: true,
  },
  {
    id: "cheng-nan-jiu-xiang",
    title: "城南旧巷",
    type: "电视剧",
    year: 2021,
    rating: 8.4,
    heat: 7340,
    status: "已完结",
    genre: ["家庭", "年代"],
    director: "柳砚青",
    cast: ["韩景轩", "白露", "许棠"],
    duration: "40分钟/集 · 全32集",
    region: "中国大陆",
    cover: "https://readdy.ai/api/search-image?query=nostalgic%20family%20drama%20poster%20of%20a%20narrow%20old%20alley%20with%20red%20brick%20walls%20and%20laundry%20hanging%20between%20windows%20at%20golden%20hour%2C%20warm%20amber%20and%20muted%20blue%20shadows%2C%20minimal%20key%20art&width=600&height=900&seq=work-cover-06&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=cinematic%20shot%20of%20a%20narrow%20old%20chinese%20alley%20at%20golden%20hour%20with%20warm%20sunlight%20and%20hanging%20laundry%2C%20nostalgic%20warm%20tones%2C%20film%20still&width=1600&height=900&seq=work-still-06&orientation=landscape",
    synopsis: "一条城南的老巷，住着三代人。有人在等待回不来的信，有人在守着开不下去的小店，也有人在执意离开与留下之间反复踱步。时光在青砖缝里慢慢流过，那些说不出口的爱，最后都落进了一碗热汤里。",
  },
  {
    id: "feng-qi-dun-huang",
    title: "风起敦煌",
    type: "电影",
    year: 2023,
    rating: 8.7,
    heat: 8460,
    status: "已上映",
    genre: ["历史", "剧情"],
    director: "秦子墨",
    cast: ["江暮辞", "苏晚宁", "池砚"],
    duration: "142分钟",
    region: "中国大陆",
    cover: "https://readdy.ai/api/search-image?query=historical%20epic%20movie%20poster%20of%20ancient%20desert%20dunes%20at%20sunset%20with%20a%20lone%20caravan%20silhouette%20and%20a%20distant%20cave%20temple%2C%20warm%20amber%20and%20deep%20navy%20sky%2C%20minimal%20grand%20key%20art%2C%20high%20detail&width=600&height=900&seq=work-cover-07&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=cinematic%20sweeping%20desert%20dune%20landscape%20at%20sunset%20with%20long%20shadows%20and%20a%20distant%20caravan%2C%20warm%20amber%20light%20against%20deep%20blue%20sky%2C%20epic%20film%20still&width=1600&height=900&seq=work-still-07&orientation=landscape",
    synopsis: "盛唐年间，一位画师奉命前往敦煌摹绘壁画。在那片被风沙反复掩埋的土地上，他遇见了守护洞窟的匠人与远征的商队，也开始用画笔记录下一个时代的光。当风再起时，留下的是颜色，也是信念。",
  },
  {
    id: "di-qi-feng-xin",
    title: "第七封信",
    type: "电影",
    year: 2025,
    rating: 8.5,
    heat: 7980,
    status: "即将上映",
    genre: ["爱情", "剧情"],
    director: "沈亦舟",
    cast: ["陆屿", "温以宁", "叶清欢"],
    duration: "112分钟",
    region: "中国大陆",
    cover: "https://readdy.ai/api/search-image?query=romantic%20drama%20poster%20of%20a%20handwritten%20letter%20and%20a%20dried%20flower%20on%20a%20wooden%20table%20beside%20a%20window%20with%20soft%20golden%20light%2C%20warm%20cream%20and%20muted%20blue%20tones%2C%20tender%20minimal%20key%20art&width=600&height=900&seq=work-cover-08&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=cinematic%20soft%20focus%20scene%20of%20letters%20and%20a%20dried%20flower%20on%20a%20wooden%20desk%20by%20a%20sunlit%20window%2C%20warm%20cream%20tones%2C%20tender%20romantic%20film%20still&width=1600&height=900&seq=work-still-08&orientation=landscape",
    synopsis: "她在一间旧书店里发现了六封没有署名的信，每一封都写于同一个秋天的不同年份。为了找到写信的人，她开始等待第七封。这是一个关于等待、错过与刚刚好的故事，温柔得像午后落在纸页上的光。",
  },
  {
    id: "an-yong",
    title: "暗涌",
    type: "电视剧",
    year: 2025,
    rating: 8.9,
    heat: 8890,
    status: "热播中",
    genre: ["谍战", "悬疑"],
    director: "周慕白",
    cast: ["顾承宇", "池砚", "林知夏"],
    duration: "44分钟/集 · 全38集",
    region: "中国大陆",
    cover: "https://readdy.ai/api/search-image?query=spy%20thriller%20drama%20poster%20of%20a%20man%20in%20a%20long%20coat%20standing%20in%20a%20vast%20dark%20hall%20with%20a%20shaft%20of%20cold%20light%2C%20deep%20navy%20and%20gray%20tones%20with%20a%20hint%20of%20amber%2C%20tense%20minimal%20key%20art&width=600&height=900&seq=work-cover-09&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=cinematic%20tense%20scene%20of%20a%20dark%20grand%20hall%20with%20a%20single%20shaft%20of%20cold%20light%20and%20a%20solitary%20figure%2C%20deep%20navy%20gray%20atmosphere%2C%20spy%20thriller%20film%20still&width=1600&height=900&seq=work-still-09&orientation=landscape",
    synopsis: "平静的水面下，暗流从未停止。一份被截获的电文，让潜伏多年的身份被迫提前暴露。信任与背叛在同一个屋檐下交替上演，每一次对视都可能是一场对峙。《暗涌》以克制的笔触，写尽无声战场上的惊心动魄。",
    featured: true,
  },
  {
    id: "sheng-xia-wei-yang",
    title: "盛夏未央",
    type: "电影",
    year: 2024,
    rating: 8.2,
    heat: 7120,
    status: "已上映",
    genre: ["青春", "爱情"],
    director: "柳砚青",
    cast: ["陆屿", "温以宁", "许棠"],
    duration: "108分钟",
    region: "中国大陆",
    cover: "https://readdy.ai/api/search-image?query=youth%20romance%20movie%20poster%20of%20two%20bicycles%20leaning%20against%20a%20wall%20under%20summer%20green%20trees%20with%20sunlight%20flares%2C%20vivid%20green%20and%20warm%20golden%20light%20with%20a%20touch%20of%20deep%20blue%20sky%2C%20fresh%20minimal%20key%20art&width=600&height=900&seq=work-cover-10&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=cinematic%20sunny%20summer%20scene%20of%20green%20tree%20lined%20avenue%20with%20sunlight%20flares%20and%20two%20bicycles%2C%20fresh%20vibrant%20green%20and%20golden%20light%2C%20youth%20film%20still&width=1600&height=900&seq=work-still-10&orientation=landscape",
    synopsis: "毕业的那个夏天，他们约好要一起去看海。可计划总被生活打乱，承诺也一次次延后。多年后重逢，他们终于明白，那个未完成的夏天，其实从未真正结束。这是一封写给所有青春的信。",
  },
  {
    id: "dai-hao-bei-ji-xing",
    title: "代号·北极星",
    type: "电视剧",
    year: 2022,
    rating: 8.3,
    heat: 6980,
    status: "已完结",
    genre: ["动作", "悬疑"],
    director: "秦子墨",
    cast: ["顾承宇", "白露", "陆屿"],
    duration: "43分钟/集 · 全30集",
    region: "中国大陆",
    cover: "https://readdy.ai/api/search-image?query=action%20thriller%20poster%20of%20a%20figure%20with%20a%20rifle%20on%20a%20dark%20harbor%20at%20night%20with%20a%20glowing%20compass%20symbol%2C%20deep%20navy%20and%20sharp%20amber%20accent%2C%20tense%20minimal%20key%20art&width=600&height=900&seq=work-cover-11&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=cinematic%20tense%20night%20harbor%20scene%20with%20shipping%20containers%20and%20cold%20blue%20lighting%20with%20warm%20amber%20accents%2C%20action%20thriller%20film%20still&width=1600&height=900&seq=work-still-11&orientation=landscape",
    synopsis: "一支被解散多年的特勤小队，因为一枚代号“北极星”的加密坐标重新集结。他们要护送一名证人穿越三座城市，却发现自己早已被人列入追捕名单。速度、信任与牺牲，组成了这场没有退路的奔袭。",
  },
  {
    id: "xue-luo-wu-sheng",
    title: "雪落无声",
    type: "电影",
    year: 2021,
    rating: 8.6,
    heat: 6640,
    status: "已上映",
    genre: ["文艺", "剧情"],
    director: "周慕白",
    cast: ["韩景轩", "白露", "池砚"],
    duration: "122分钟",
    region: "中国大陆",
    cover: "https://readdy.ai/api/search-image?query=art%20house%20movie%20poster%20of%20a%20silent%20snowy%20village%20with%20a%20single%20warm%20lit%20window%20at%20dusk%2C%20soft%20blue%20snow%20and%20warm%20amber%20glow%2C%20meditative%20minimal%20key%20art%2C%20high%20detail&width=600&height=900&seq=work-cover-12&orientation=portrait",
    still: "https://readdy.ai/api/search-image?query=cinematic%20quiet%20snowy%20village%20at%20dusk%20with%20a%20single%20warm%20lit%20window%20and%20falling%20snow%2C%20soft%20blue%20and%20amber%20tones%2C%20meditative%20film%20still&width=1600&height=900&seq=work-still-12&orientation=landscape",
    synopsis: "大雪封山的日子，一位老教师独自留在村里，等待一封迟到了四十年的道歉。他每天清扫院中的雪，像在清扫一段无人提及的往事。当雪停下时，他终于说出了那句藏在心底的话。《雪落无声》安静，却震耳欲聋。",
  },
];

export const workGenres = ["全部", "电影", "电视剧", "悬疑", "剧情", "奇幻", "科幻", "历史", "家庭", "犯罪", "爱情", "动作"];
export const workYears = ["全部", "2025", "2024", "2023", "2022", "2021"];
export const workStatusList = ["全部", "热播中", "即将上映", "已上映", "已完结"];